import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { SnackbarProvider } from "notistack";

import {
  getRefreshToken,
  refreshToken,
  resetTradeLoginStatus,
} from "./redux/actions";
import RootNavigation from "./routes/RouteNavigation";
import theme from "./config/theme";
import { STATUS } from "./redux/constants";
import { getCookie } from "./services/cookie";
import CookieConsent from "react-cookie-consent";
import { Box, CircularProgress } from "@mui/material";
import OverlayLoader from "./components/Loader/Loader";

function App() {
  const dispatch = useDispatch();
  const [isCarbonLoading, setIsCarbonLoading] = useState(false);
  const refreshStatus = useSelector((state) => state.auth.refreshStatus);
  const authToken = useSelector((state) => state.auth.isAuthenticated);
  const authStatus = useSelector((state) => state.auth.status);
  const loading = useSelector((state) => state.auth.isLoading);
  const isTradePlatform = window.location.pathname.includes("trade");

  const auth = useSelector((state) => state.auth);
  useEffect(() => {
    const checkTokenExpiry = () => {
      const expiryTime = getCookie("access_token_expiry");
      const currTime = new Date().getTime();
      console.log(
        "from app=============> time logs",
        new Date(Number(expiryTime)),
        new Date(currTime)
      );

      if (
        Number(expiryTime) - currTime < 60000 &&
        refreshStatus !== STATUS.RUNNING
      ) {
        if (authToken && !isTradePlatform) {
          console.log("from app=============>");
          dispatch(getRefreshToken());
        }
      }
    };
    console.log("nik app", getCookie("access_token_expiry"));

    const tokenCheckInterval = setInterval(checkTokenExpiry, 10000);

    return () => {
      clearInterval(tokenCheckInterval);
    };
  }, [dispatch, authToken, refreshStatus]);
  //nikhil
  useEffect(() => {
    dispatch(refreshToken());
  }, [dispatch]);

  useEffect(() => {
    if (auth.proxySustainabilityManagerLogin === STATUS.SUCCESS) {
      window.location.pathname = "dashboard";
    } else if (auth.tradeLoginArroUser === STATUS.RUNNING) {
      setIsCarbonLoading(true);
    } else if (auth.tradeLoginArroUser === STATUS.SUCCESS) {
      // window.location.pathname = "trade/dashboard-internal";
      window.open("/trade/dashboard-internal", "_blank", "noopener,noreferrer");
      dispatch(resetTradeLoginStatus());
    }
  }, [auth]);

  return (
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <OverlayLoader open={loading} />
        <SnackbarProvider maxSnack={3}>
          {refreshStatus === STATUS.RUNNING ? (
            <div
              style={{
                width: "100%",
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <RootNavigation />
          )}
          {authToken && (
            <CookieConsent
              location="bottom"
              buttonText="I understand"
              cookieName="myCookieConsent"
              style={{ background: "#5A404E", zIndex: 2000 }}
              buttonStyle={{
                background: "#8C2148",
                color: "#ffffff",
                fontSize: "16px",
                padding: "6px 10px",
                borderRadius: "8px",
              }}
              expires={150}
            >
              We use essential cookies to ensure the basic functionality of our
              website and to keep it secure. These cookies are necessary for the
              proper operation of the site and cannot be turned off. By
              continuing to use our website, you agree to the use of these
              essential cookies. Thank you for your understanding
              and cooperation.
            </CookieConsent>
          )}
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
